module.exports = __webpack_public_path__ + "img/pro-body-photo1.5909bf1c.png";